import { formatCurrency } from "@/common/utils/formatters";
import { useQueryClient } from "@tanstack/react-query";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import CreateDiagnosticObjectiveActivity from "./CreateDiagnosticObjectiveActivity";
import { MaintenanceDirectiveObjectiveData } from "@/features/maintenance/features/workflows/types/forwardings/directiveEntries/directiveEntry.type";
import DiagnosticObjectiveActivityItem from "./DiagnosticObjectiveActivityItem";

interface DiagnosticEntryUpdateObjectiveAttributesDiagnosticObjectiveActivitiesProps {
  diagnosticObjective: MaintenanceDirectiveObjectiveData;
}

const DiagnosticEntryUpdateObjectiveAttributesDiagnosticObjectiveActivities = ({
  diagnosticObjective,
}: DiagnosticEntryUpdateObjectiveAttributesDiagnosticObjectiveActivitiesProps) => {
  const { forwardingId } = useParams();

  const queryClient = useQueryClient();

  const forwardingState = queryClient.getQueryState([
    "maintenanceForwarding",
    forwardingId,
  ]);

  const activitiesCountDisplay = useMemo(() => {
    const count = diagnosticObjective.diagnostic_activities?.length || 0;

    if (count === 0) {
      return "Nenhum serviço";
    }

    if (count === 1) {
      return "1 Serviço";
    }

    return `${count} Serviços`;
  }, [forwardingState?.dataUpdatedAt]);

  const totalValueSum = useMemo(() => {
    return (
      diagnosticObjective.diagnostic_activities?.reduce((prev, curr) => {
        return prev + Number(curr.total_value);
      }, 0) || 0
    );
  }, [forwardingState?.dataUpdatedAt]);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex flex-col">
          <p className="font-bold text-base">Serviços</p>

          <div className="flex items-center gap-0.5 text-xs">
            <span>{activitiesCountDisplay}</span>

            <span>•</span>

            <span className="text-valid">{formatCurrency(totalValueSum)}</span>
          </div>
        </div>

        <CreateDiagnosticObjectiveActivity
          diagnosticObjectiveId={diagnosticObjective.id}
        />
      </div>

      <div className="flex flex-col gap-3">
        {diagnosticObjective.diagnostic_activities?.map(
          (diagnosticActivity) => (
            <DiagnosticObjectiveActivityItem
              key={diagnosticActivity.id}
              diagnosticActivity={diagnosticActivity}
            />
          ),
        )}
      </div>
    </div>
  );
};

export default DiagnosticEntryUpdateObjectiveAttributesDiagnosticObjectiveActivities;
